<template>
  <div>
    <div 
      v-if="url"
      class="btn-container"
    >
      <a :href="url" target="_blank">
        <button
          type="button"
          class="btn btn-default filter-button"
          :style="{ 
            'background':`${backgroundColor}` ,
            'color': `${textColor}` ,
            'border-color':`${borderColor}` ,
            'border-width': `${borderWidth}px` ,
            'width': `${width}`
          }"
        >
          <span class="current-option">{{ name }}</span>
        </button>
      </a>
    </div>
    <div 
      v-else
      class="btn-container"
    >
      <button
        type="button"
        class="btn btn-default filter-button"
        :style="{ 
          'background': (hasActive && checkActiveValue) ? (checkActiveValue == currentValue) ? `${activeBackgroundColor}` : `${backgroundColor}` : `${backgroundColor}`, 
          'color': (hasActive && checkActiveValue) ? (checkActiveValue == currentValue) ? `${activeTextColor}` : `${textColor}` : `${textColor}`,
          'border-color': (hasActive && checkActiveValue) ? (checkActiveValue == currentValue) ? `${activeBorderColor}` : `${borderColor}` : `${borderColor}` , 
          'border-width':`${borderWidth}px` , 
          'width': `${width}`
        }"
      >
        <span class="current-option">{{ name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: () => '',
    },
    backgroundColor: {
      type: String,
      default: () => '#FEE100',
    },
    borderColor: {
      type: String,
      default: () => '#000000',
    },
    borderWidth: {
      type: Number,
      default: () => 2,
    },
    textColor: {
      type: String,
      default: () => '#000000',
    },
    hasActive: {
      type: Boolean,
      default: () => false,
    },
    currentValue: {
      default: () => null,
    },
    checkActiveValue: {
      default: () => null,
    },
    activeTextColor: {
      type: String,
      default: () => '#000000',
    },
    activeBackgroundColor: {
      type: String,
      default: () => '#FEE100',
    },
    activeBorderColor: {
      type: String,
      default: () => '#FEE100',
    },
    width: {
      type: String,
      default: () => 'auto',
    },
    url: {
      type: String,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  justify-content: center;
}

.filter-button {
  text-align: center;
  padding: 2px 10px;
  box-shadow: unset;
  outline-width: 0px;
  display: flex;
  justify-content: center;
  border-style: solid;
  border-radius: 30px;
}

.filter-button:focus {
  background: #FEE100;
  outline-width: 0px;
}

.current-option {
  font-size: 14px;
  white-space: break-spaces;
}

.down-arrow {
  font-size: 16px;
}
</style>
